import { Form, Button } from "antd";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import BasicTab from "./tabs/edit/BasicTab";
import axios from 'utils/axios';
import configFile from 'config.json';
import { useCallback, useEffect, useMemo, useState } from "react";

const API_BASE = `${configFile.PROD_SERVER_URL}`

const CreateComboPage = () => {
  const [basicForm] = Form.useForm();
  const [availableImages, setAvailableImages] = useState([])
  const [tags, setTags] = useState([])
  
  const navigate = useNavigate();

  const fetchImages = useCallback(async () => {
    try {
      const { data: result } = await axios.post(`${API_BASE}/menu2/image/list`);
      setAvailableImages(result?.data || []);
    } catch (err) {
      console.log(err);
    }
  }, []);

  const fetchTags = useCallback(async () => {
    try {
      const { data: result } = await axios.post(`${API_BASE}/tag/getAllTags`)
      setTags(result?.data || []);
    } catch (err) {
      console.log(err);
    }
  }, []);

  const emptyDeal = useMemo(() => ({}), []);

  useEffect(() => {
      fetchImages();
      fetchTags();
  }, [fetchImages, fetchTags]);

  return (
    <Page>
      <HeaderCard>
        <HeaderLeft>
          <Breadcrumb>Комбо / Комбо нэмэх</Breadcrumb>
        </HeaderLeft>
        <HeaderActions>
          <Button onClick={() => navigate("/deals")}>Буцах</Button>
        </HeaderActions>
      </HeaderCard>
      <BasicTab deal={emptyDeal} form={basicForm} tagOptions={tags} availableImages={availableImages} />
    </Page>
  );
};

const Page = styled.div`
  --ink-900: #1f2a33;
  --ink-700: #3b4b5a;
  --ink-500: #6b7a88;
  --blue-700: #0958d9;
  --blue-600: #1677ff;
  --blue-500: #4096ff;
  --blue-200: #bae0ff;
  --card-bg: rgba(255, 255, 255, 0.94);
  --card-border: rgba(22, 119, 255, 0.18);
  --shadow-soft: 0 18px 50px rgba(33, 49, 63, 0.1);
  --shadow-float: 0 16px 30px rgba(22, 119, 255, 0.2);
  --radius-lg: 8px;
  --radius-md: 6px;
  --radius-sm: 5px;

  padding: 12px 16px 16px;
  background: radial-gradient(circle at 15% 15%, rgba(22, 119, 255, 0.2), transparent 45%),
    radial-gradient(circle at 85% 25%, rgba(186, 224, 255, 0.45), transparent 55%),
    linear-gradient(140deg, #f5f8ff 0%, #eef3fb 55%, #f6f7fb 100%);
  min-height: 100vh;
  color: var(--ink-900);
  font-family: "Sora", "Manrope", "SF Pro Display", sans-serif;
  letter-spacing: 0.01em;

  * {
    box-sizing: border-box;
  }

  .ant-btn,
  .ant-input,
  .ant-input-affix-wrapper,
  .ant-select-selector,
  .ant-picker,
  .ant-modal-content,
  .ant-modal-header,
  .ant-modal-footer,
  .ant-radio-button-wrapper,
  .ant-tag {
    border-radius: var(--radius-sm) !important;
  }
`;

const HeaderCard = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 18px 22px;
  margin-bottom: 16px;
  border-radius: var(--radius-lg);
  background: var(--card-bg);
  box-shadow: var(--shadow-soft);
  border: 1px solid var(--card-border);
  backdrop-filter: blur(8px);
`;

const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Breadcrumb = styled.span`
  text-transform: uppercase;
  letter-spacing: 0.12em;
  font-size: 12px;
  color: var(--ink-500);
`;

const HeaderActions = styled.div`
  display: flex;
  gap: 12px;

  .ant-btn-primary {
    background: linear-gradient(135deg, var(--blue-600), var(--blue-500));
    border: none;
    box-shadow: var(--shadow-float);
  }
`;

export default CreateComboPage;
